// Pointer dragging moves the native Dawn slider; its scroll listener still owns
// the active slide, thumbnail state and announcements.
if (!document.documentElement.hasAttribute('data-hollow-legacy-drag')) {
  document.documentElement.setAttribute('data-hollow-legacy-drag', '');
  let drag = null;
  let blockedClick = null;
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const track = event.target.closest('.hollow-pdp--legacy .product__media-list, .hollow-pdp--hat .product__media-list');
    if (!track || track.closest('[data-hollow-gallery]')) return;
    drag = { track, id: event.pointerId, startX: event.clientX, startLeft: track.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const delta = event.clientX - drag.startX;
    if (!drag.moved && Math.abs(delta) < 5) return;
    if (!drag.moved) {
      drag.moved = true;
      drag.track.setPointerCapture?.(drag.id);
      drag.track.style.scrollSnapType = 'none';
      drag.track.style.scrollBehavior = 'auto';
    }
    event.preventDefault();
    drag.track.scrollLeft = drag.startLeft - delta;
  }, { passive: false });
  const end = event => {
    if (!drag || event.pointerId !== drag.id) return;
    const { track, id, moved } = drag;
    drag = null;
    if (!moved) return;
    blockedClick = { track, until: performance.now() + 500 };
    if (track.hasPointerCapture?.(id)) track.releasePointerCapture(id);
    track.style.removeProperty('scroll-snap-type');
    track.style.removeProperty('scroll-behavior');
    if (track.clientWidth) track.scrollTo({ left: Math.round(track.scrollLeft / track.clientWidth) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('dragstart', event => {
    if (event.target.closest('.hollow-pdp--legacy .product__media-list, .hollow-pdp--hat .product__media-list')) event.preventDefault();
  });
  document.addEventListener('click', event => {
    if (blockedClick && performance.now() < blockedClick.until && blockedClick.track.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    blockedClick = null;
  }, true);
}
